/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	useCommentQueryParamsCommentLocationQuery$data as useCommentQueryParamsCommentLocationQuery,
	useCommentQueryParamsCommentLocationQuery$variables as useCommentQueryParamsCommentLocationQueryVariables,
} from '../__generated__/useCommentQueryParamsCommentLocationQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { useCommentQueryParamsCommentLocationQuery$data } from '../__generated__/useCommentQueryParamsCommentLocationQuery.graphql.ts';
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_container_Content = NonNullable<NonNullable<NonNullable<NonNullable<useCommentQueryParamsCommentLocationQuery$data['comments']>['nodes']>[number]>['container']>;
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment = NonNullable<NonNullable<NonNullable<useCommentQueryParamsCommentLocationQuery$data['comments']>['nodes']>[number]>['location'];
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment = NonNullable<NonNullable<NonNullable<useCommentQueryParamsCommentLocationQuery$data['comments']>['nodes']>[number]>['location'];
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location = NonNullable<NonNullable<NonNullable<useCommentQueryParamsCommentLocationQuery$data['comments']>['nodes']>[number]>['location'];
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment = NonNullable<NonNullable<NonNullable<useCommentQueryParamsCommentLocationQuery$data['comments']>['nodes']>[number]>;
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList = NonNullable<useCommentQueryParamsCommentLocationQuery$data['comments']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

